import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Button, Form, Input, Select, Typography } from "antd";
import PropTypes from "prop-types";
import "./paymentEdit.scss";

import { paymentUpdate, programDetail } from "../../../apis/admin";
import { replaceUrlByParams } from "../../../utils/api";
import { PAGE } from "../../../utils/constants";
import { AppContext } from "../../../App";
import { paymentMethodText } from "../../../components/paymentStatusTemplate/paymentStatusTemplate";

PaymentEditPage.propTypes = {
  location: PropTypes.object,
  state: PropTypes.object,
  paymentData: PropTypes.object,
};

function PaymentEditPage(props) {
  let history = useHistory();
  const { pid, id } = useParams();
  const [form] = Form.useForm();
  const { setLoading } = useContext(AppContext);
  const { Option } = Select;
  const { TextArea } = Input;
  const { Title } = Typography;

  const [program, setProgram] = useState({});

  useEffect(() => {
    getProgramDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps,
  }, []);

  const getProgramDetail = async () => {
    setLoading(true);
    try {
      const res = await programDetail(pid);
      if (res.error) {
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        setProgram(res.configuration);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.location.state) {
      form.setFieldsValue(props.location.state.paymentData);
    } else {
      history.goBack();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFinish = async (value) => {
    setLoading(true);
    try {
      let res = await paymentUpdate(
        pid,
        id,
        value.status,
        value.paymentMethod,
        value.remarks
      ); // get back id
      if (res.error) {
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        history.push({
          pathname: `${replaceUrlByParams(PAGE.ADMIN_APPLICATION_DETAIL, {
            ":pid": pid,
            ":id": id,
          })}`,
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };

  return (
    <div className="payment-edit-page">
      <Title level={4}>編輯付款狀態</Title>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        hideRequiredMark={true}
      >
        <div className="form-section">
          <Form.Item
            name="status"
            label="付款狀態"
            rules={[{ required: true, message: "請選擇付款狀態" }]}
          >
            <Select>
              <Option value="pending">待付款</Option>
              <Option value="paid">已付款</Option>
            </Select>
          </Form.Item>

          {"payment" in program && (
            <Form.Item
              name="paymentMethod"
              label="付款方式"
              rules={[{ required: true, message: "請選擇付款方式" }]}
            >
              <Select>
                {program.payment.paymentMethod.map((id, i) => (
                  <Option key={i} value={id}>
                    {paymentMethodText(id)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
        </div>
        <Form.Item name="remarks" label="備註">
          <TextArea rows={4} />
        </Form.Item>

        <div className="button-container">
          <Button onClick={() => history.goBack()}>取消</Button>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              儲存
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
}

export default PaymentEditPage;
